import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesFiscal() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "CFDI", items: [
      { label: "Facturas", icon: "fas fa-file-invoice-dollar", color: "#3b82f6", href: "/ListadoFacturas", desc: "Emision y listado", enabled: !!user.facturasFiscal },
      { label: "Complementos de Pago", icon: "fas fa-money-bill-wave", color: "#10b981", href: "/ListadoComplementosPago", desc: "Complementos emitidos", enabled: !!user.compPagosFiscal },
      { label: "Notas de Credito", icon: "fas fa-money-check-alt", color: "#6366f1", href: "/ListadoNotasCredito", desc: "Notas de credito", enabled: !!user.notasCreditoFiscal },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesFiscal", desc: "Devoluciones fiscales", enabled: !!user.devolucionesFiscal },
    ]},
    { section: "Pagos", items: [
      // { label: "Pagos a Facturas", icon: "fas fa-money-bill-wave", color: "#f59e0b", href: "/ListadoPagosFacturas", desc: "Facturas con pago", enabled: !!user.compPagosFiscal },
      { label: "Abonos Facturas", icon: "fas fa-money-bill-wave", color: "#f59e0b", href: "/ListadoAbonosFacturas", desc: "Abonos aplicados", enabled: !!user.compPagosFiscal },
    ]},
    { section: "Configuración", items: [
      { label: "Registrar FIEL", icon: "fas fa-file-alt", color: "#8b5cf6", href: "/RegistrarEmpresas", desc: "Certificados FIEL", enabled: !!user.menu_fiscal },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice-dollar", color: "#64748b", href: "/EstadoCuentaK", desc: "Edo. cta. fiscal", enabled: !!user.menu_fiscal },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Fiscal"
      descripcion="Facturacion, complementos y notas de credito"
      icono="fas fa-file-invoice-dollar"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesFiscal;
